import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'inTime'
})
export class InTimePipe implements PipeTransform {

  transform(value: number, capitalize: boolean = true): string {
    let result = '';
    if (value === 180) {
      result = 'In 6 months';
    } else {
      result = 'In 1 year';
    }
    if (!result) return '';

    return capitalize
      ? result
      : result.charAt(0).toLowerCase() + result.slice(1);
  }

}
